import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitorsByHour } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitorsByHourChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitorsByHour();
  const { isManualRefreshing } = useMutateOnRefresh(mutate);

  return <TrafficChartCard baseKey='trafficVisitorsByHour' isLoading={isLoading || isManualRefreshing} data={data!} />;
};

export default VisitorsByHourChart;
